import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import EnterpriseBulkPaymentFlow from '../../components/Payment/EnterpriseBulkPaymentFlow';

/**
 * PAGE: PAIEMENT DE MASSE (ENTREPRISE)
 * 
 * Permet de traiter les paiements groupés des entreprises
 */

const PaymentBulk = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto py-6 space-y-6">
      {/* Bouton retour */}
      <button
        onClick={() => navigate('/admin/payments/entreprises')}
        className="flex items-center text-gray-600 hover:text-primary-600 transition-colors duration-200"
      >
        <ArrowLeft className="h-5 w-5 mr-2" />
        <span className="text-sm font-medium">Retour aux paiements entreprises</span>
      </button>

      {/* En-tête */}
      <div>
        <h1 className="text-3xl font-bold">Paiements de Masse</h1>
        <p className="text-muted-foreground mt-2">
          Traitez les paiements groupés des entreprises
        </p>
      </div>

      {/* Flux de paiements de masse réutilisable */}
      <EnterpriseBulkPaymentFlow />
    </div>
  );
};

export default PaymentBulk;
